import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";

import {AppContext } from "../../AppContext";
import { LogInfo, LogError } from "../../common/FetchHelpers";

import LoadingComp from "../common/LoadingComp";

const LoginComp = () => {
  const history = useHistory();
  const location = useLocation();
  const [appContext,setAppContext] = useContext(AppContext);

  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [formData, setFormData] = useState({ userId: "", password: "" });

  const qparams = useParams();  
  let { from } = location.state || { from: { pathname: "/home"} };

  const getAppConfig = ()=>{
    clearLocalStorage();
    const responseFromServer = fetch('/auth/config', {
      method: "GET",
      cache: "no-cache",
    })
    .then(response => response.json())
    .then(data => {
        //console.log(data);
        const version = localStorage.getItem("VERSION")||'';
        //console.log(`Local Version ${version}`);

        if(version !== data.version){
          window.location.replace('/login');
        }

        setAppContext({
          ...appContext,
          version:data.version,
          clientId:data.clientId,
          appFeature:data.appFeature
        });

        localStorage.setItem("VERSION", data.version);
        localStorage.setItem("CLIENT_ID", data.clientId);
        
        localStorage.setItem("ALLOW_UNKNOWN_BROKERDEALER", data.allowUnknownBrokerDealer);
        localStorage.setItem("ENABLE_ACCOUNT_APPROVAL", data.enableAccountApproval);
        localStorage.setItem("ENABLE_CREATE_ON_BEHALF", data.allowCreateAccountForOther);
        localStorage.setItem("APP_FEATURE", JSON.stringify(data.appFeature));

        if(data.sso){
          LogInfo("SSO configuration found.");
          localStorage.setItem("SSO_LOGIN_URL", data.sso.ssoLoginUrl);
          if(data.sso.ssoLogoutUrl && data.sso.ssoLogoutUrl !== ''){
            localStorage.setItem("SSO_LOGOUT_URL", data.sso.ssoLogoutUrl);
          }
          else{
            localStorage.setItem("SSO_LOGOUT_URL", data.sso.ssoLoginUrl);
          }
          if(qparams.ssouser){
            if(qparams.ssouser === "bypass")
            {
              setShowLogin(true);
            } else {
              getSsoUser(qparams.ssouser);
            }
          }
          else{
            window.location.replace(data.sso.ssoLoginUrl);
          }
        } else {
          setShowLogin(true);
        }
      })
      .catch(error =>{
        console.error(error);
        //LogError(error);
      })

  }

  const getSsoUser = (ssouser) => {
    //console.log('getSsoUser()');
    setLoading(true);
    const ssoLogoutUrl = localStorage.getItem("SSO_LOGOUT_URL")|| "";
    fetch('/auth/login', {
      method: "POST",
      cache: "no-cache",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: ssouser,password:null }),
    })
    .then(response => response.json())
    .then(json =>{
      //console.log(json);
      if (json.userId != null) {
        const tokenInfo = {
          token:json.token,
          expire:Date.parse(json.tokenExpire),
          refreshToken:json.refreshToken
        }
        
        const sessionUser = {
          userId: json.userId,
          userName: json.userName,
          email: json.email,
          role: json.role,
          submitOnBehalf: json.submitOnBehalf,
          userCategory: json.userCategory
        };
        
        localStorage.setItem("TOKEN", json.token);
        localStorage.setItem("TOKENINFO", JSON.stringify(tokenInfo));
        localStorage.setItem("USER", JSON.stringify(sessionUser));
        const clientId = localStorage.getItem("CLIENT_ID")|| "";
        setAppContext({
          ...appContext,
          auth: true,
          user: sessionUser,
          token:json.token,
          clientId
        });
        
        setLoading(false);
        setShowError(false);
        //console.log('getSsoUser() response processing complete.');
        history.push(from.pathname);
      }
    })
    .catch(error => {
      //LogError(error);
      setLoading(false);
      setShowError(true);
      window.location.replace(ssoLogoutUrl);
    });

  };


  const validateResponse = (json) => {
      //console.log('validateResponse()');
      if (json.userId != null) {
        const tokenInfo = {
          token:json.token,
          expire:Date.parse(json.tokenExpire),
          refreshToken:json.refreshToken
        }
        //console.log(tokenInfo);

        const sessionUser = {
          userId: json.userId,
          userName: json.userName,
          email: json.email,
          role: json.role,
          submitOnBehalf: json.submitOnBehalf,
          userCategory: json.userCategory
        };

        localStorage.setItem("TOKEN", json.token);
        localStorage.setItem("TOKENINFO", JSON.stringify(tokenInfo));
        localStorage.setItem("USER", JSON.stringify(sessionUser));
        
        setAppContext({
          ...appContext,
          auth: true,
          user: sessionUser,
          stamp:json.securityStamp,
          token:json.token
        });
        
        setLoading(false);
        setShowError(false);
        history.push(from.pathname);
        
      } else {
        setLoading(false);
        setShowError(true);
    }
  };



  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };



  const handleSubmit = (event) => {
    //console.log('handleSubmit()');
    setLoading(true);
    event.preventDefault();
    var loginData = new FormData();
    loginData.append("userId", formData.userId);
    loginData.append("password", formData.password);
    fetch('/auth/login', {
      method: "POST",
      cache: "no-cache",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: formData.userId,password:formData.password }),
    })
    .then(response => response.json())
    .then(result => {
      validateResponse(result);
    })
    .catch(error => {
      setLoading(false);
      setShowError(true);
    });

  };

  const clearLocalStorage = ()=>{
    localStorage.removeItem("CLIENT_ID");
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("TOKENINFO");
    localStorage.removeItem("USER");
    localStorage.removeItem("SSO_LOGIN_URL");
    localStorage.removeItem("SSO_LOGOUT_URL");
    localStorage.removeItem("APP_FEATURE");
    localStorage.removeItem("NOTIFICATION_COUNT");
  }


  useEffect(() => {
    //console.log('useEffect: getAppConfig()');
    getAppConfig();
  }, []);


  return (
    
      <div className="center-container">

        {showLogin ? (

        <form onSubmit={handleSubmit} className="form login-form" id="login-page">
          <h3 className="login-header">Login</h3>

          <div className="form-body">
            <div className="form-row">
              <div className="form-item">
                <label className="form-item-label-short">User ID : </label>
                <input name="userId" className="form-item-value" type="text" placeholder="userId" onChange={handleChange} disabled={loading ? "disabled" : ""}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-item">
                <label className="form-item-label-short">Password : </label>
                <input name="password" className="form-item-value" type="password" placeholder="password" onChange={handleChange} disabled={loading ? "disabled" : ""}/>
              </div>
            </div>
          </div>
          <div className="form-footer">
            <div className="form-status red">
              {showError && (
                <div className="form-status red">
                  UserID or Password Invalid. Please Try Again
                </div>
              )}
              {loading && <LoadingComp small={true} />}
            </div>
            <div className="btn-group">
              <button id="btnLoadProductDetail" type="submit" className="btn btn-primary">
                Login
              </button>
            </div>
          </div>
          <div className="list-footer center-container">
            <Link to="/forgotpassword">Forgot Password</Link>
          </div>
        </form>
        ):(
          <div>Please wait...</div>
        )}
      </div>
    
  );
};

export default LoginComp;
